<div class="flex qty-item flex-middle b-a b-col-4"
  [class.is-busy]="status?.busy">
  <button class="col-1 p-l-1 p-r-1 flex flex-middle"
    [class.is-disabled]="!canLess() || status?.busy"
    [attr.aria-label]="'Remove one item' | translate"
    (click)="less()"
    cy-decreaseQty>
    <i class="icon-minus qty-icon"
    aria-hidden="true"></i>
  </button>

  <div class="pos-relative">
    <!-- loader -->
    @if (status?.busy) {
      <div class="fill flex flex-middle flex-justify-center"
        >
        <i class="icon-loading"></i>
      </div>
    }

    <input class="no-spinner center p2 m-t-1 m-b-1 qty-input"
      type="number"
      step="1"
      [disabled]="status?.busy || (!canMore() && !canLess()) "
      [attr.min]="min || null"
      cy-qtyInput
      #input
      [(ngModel)]="model"
      (blur)="validate()"
      [minWidth]="18"
      autoSizeInput>
  </div>

  <button class="col-1 p-l-1 p-r-1 flex flex-middle"
    [class.is-disabled]="!canMore() || status?.busy"
    [attr.aria-label]="'Add one item' | translate"
    (click)="more()"
    cy-increaseQty>
    <i class="icon-plus qty-icon"
    aria-hidden="true"></i>
  </button>
</div>
